import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_ProgressNotes = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_ProgressNotes' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <center><h2>PROGRESS NOTES</h2> </center>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>CLIENT'S NAME:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>MEDICAID NUMBER:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClientsName' name='txtClientsName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>DATE</span>
                        </td>
                        <td className='w-400'>
                            <span className='eleHeader'>DOCUMENTATION OF ACTIVITY</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>SIGNATURE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_1' name='txtDate_1' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_1' name='txtDocumentationOfActivity_1' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_2' name='txtDate_2' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_2' name='txtDocumentationOfActivity_2' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_3' name='txtDate_3' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_3' name='txtDocumentationOfActivity_3' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_4' name='txtDate_4' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_4' name='txtDocumentationOfActivity_4' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_5' name='txtDate_5' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_5' name='txtDocumentationOfActivity_5' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_6' name='txtDate_6' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_6' name='txtDocumentationOfActivity_6' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_7' name='txtDate_7' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_7' name='txtDocumentationOfActivity_7' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_8' name='txtDate_8' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_8' name='txtDocumentationOfActivity_8' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_9' name='txtDate_9' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_9' name='txtDocumentationOfActivity_9' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_10' name='txtDate_10' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_10' name='txtDocumentationOfActivity_10' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_11' name='txtDate_11' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_11' name='txtDocumentationOfActivity_11' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_12' name='txtDate_12' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_12' name='txtDocumentationOfActivity_12' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_13' name='txtDate_13' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_13' name='txtDocumentationOfActivity_13' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_14' name='txtDate_14' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_14' name='txtDocumentationOfActivity_14' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_15' name='txtDate_15' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_15' name='txtDocumentationOfActivity_15' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_16' name='txtDate_16' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_16' name='txtDocumentationOfActivity_16' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_17' name='txtDate_17' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_17' name='txtDocumentationOfActivity_17' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_18' name='txtDate_18' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_18' name='txtDocumentationOfActivity_18' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_19' name='txtDate_19' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_19' name='txtDocumentationOfActivity_19' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_20' name='txtDate_20' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_20' name='txtDocumentationOfActivity_20' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_21' name='txtDate_21' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_21' name='txtDocumentationOfActivity_21' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_22' name='txtDate_22' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_22' name='txtDocumentationOfActivity_22' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_23' name='txtDate_23' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_23' name='txtDocumentationOfActivity_23' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_24' name='txtDate_24' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_24' name='txtDocumentationOfActivity_24' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_25' name='txtDate_25' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_25' name='txtDocumentationOfActivity_25' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_26' name='txtDate_26' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_26' name='txtDocumentationOfActivity_26' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_27' name='txtDate_27' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_27' name='txtDocumentationOfActivity_27' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_28' name='txtDate_28' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_28' name='txtDocumentationOfActivity_28' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_29' name='txtDate_29' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_29' name='txtDocumentationOfActivity_29' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txtDate_30' name='txtDate_30' className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id='txtDocumentationOfActivity_30' name='txtDocumentationOfActivity_30' className='add-only' />
                        </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}











